import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { createCustomPlan } from "../api/createCustomPlan";

export const useCreateCustomPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, body }) => createCustomPlan(companyId, body),
    onSuccess: () => {
      toast.success("Custom plan created successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to create custom plan.");
    },
  });
};

